const today = new Date();
const yyyy = today.getFullYear();
let mm = today.getMonth() + 1; // Months start at 0!
let dd = today.getDate();
const shortid = require('shortid');

if (dd < 10) dd = '0' + dd;
if (mm < 10) mm = '0' + mm;
const state = {
    jpc:true,
    showNar:false,
    tempId:shortid.generate(),
    path:'Pro',
    proType:'painter',
    location:{pathname:"/"},
    loc:"/",
    step:0,
    direction:'left',
    firstName:'',
    middleName:'',
    lastName:'',
    email:'',
    emailVerified:false,
    verifyEmailCode:'',
    verifyEmailLater:false,
    verifyEmailSent:false,
    mobile:'',
    verifyMobile:true,
    verifyMobileCode:'',
    showCodeVerify:false,
    showCodeResent:false,
    mobileVerified:false,
    licenseNum:'',
    licenseState:'',
    password:'',
    businessName:'',
    businessPhone:'',
    businessPhoneSameAsMobile:true,
    businessType:'',
    existingAcctNum:'',
    inStoreAccount:true,
    inStoreAccountDefault:true,
    billingAddress:'',
    billingAddress2:'',
    billingCity:'',
    billingState:'',
    billingZip:'',
    billingGeo:null,
    showAddressError:false,
    ignoreAddressError:false,
    mapCenter:{lat: 42.8574185,lng: -70.6979203},
    mapZoom:7.4,
    addressOptions:[],
    nearestLocs:[],
    selectedStoreIndex:0,
    mainStore:'Boston',
    isLocal:true,
    requestOnlineAccount:false,
    requestCredit:false,
    creditLimit:0,
    payByCheck:false,
    requirePO:false,
    taxExempt:false,
    jobAccounts:[],
    authorizedToCharge:[],
    subscribeEducation:false,
    emailInvoices:false,
    subscribeMarketing:false,
    subscribePrintMarketing:false,
    accountCreationAuthorized:false,
    accountCreationSignature:'',
    accountCreationSignatureDate:mm + '/' + dd + '/' + yyyy,
    requestCardOnFile:false,
    ccName:'',
    ccNum:'',
    ccNumRedacted:'',
    ccAddress:'',
    ccAddressRedacted:'',
    ccAddress2:'',
    ccAddress2Redacted:'',
    ccCity:'',
    ccCityRedacted:'',
    ccState:'',
    ccStateRedacted:'',
    ccZip:'',
    ccZipRedacted:'',
    ccIcon:'',
    ccExpiration:'',
    ccExpirationRedacted:'',
    ccCode:'',
    ccCodeRedacted:'',
    steps:[
        // {
        //     label:'Choose Account Type',
        //     pro:false,
        //     url: '/'
        // },
        {
            label:'Contact Info',
            pro:false,
            url: '/'//'/personal-info'
        },
        {
            label:'Account Info',
            pro:false,
            url: '/account-info'
        },
        {
            label:'Address & Store',
            pro:false,
            url: '/in-store-acct'
        },
        {
            label:'Account Options',
            pro:false,
            url: '/account-options'
        },
        {
            label:'Credit Card Info',
            pro:false,
            url: '/cc-info'
        },
        {
            label:'Thank You',
            pro:false,
            url: '/thank-you'
        }
    ],
    map:null,
    placeService:null,
    formErrors:{},
    finished:false,
    showFinishing:false,
    markers:[
  {id:30,lat:42.3484401, lng:-71.0875714, name: 'Boston'},
  {id:31,lat:42.3748463, lng:-71.2101029, name: 'Waltham'},
  {id:32,lat:42.4973272, lng:-71.1242157, name: 'Woburn'},
  {id:33,lat:43.6828470, lng:-70.2905930, name: 'Portland'},
  {id:34,lat:43.6369190, lng:-70.2528170, name: 'South Portland'},
  {id:35,lat:43.7691100, lng:-70.2025700, name: 'Yarmouth'},
  {id:36,lat:43.5013610, lng:-70.4471150, name: 'Saco'},
  {id:37,lat:43.0938535, lng:-70.7939951, name: 'Portsmouth'},
  {id:38,lat:42.8160800, lng:-70.8803020, name: 'Newburyport'},
  {id:39,lat:42.9984626, lng:-70.9213558, name: 'Stratham'},
  {id:40,lat:42.3155014, lng:-71.2099528, name: 'Newton'},
  {id:40,lat:41.90544, lng:-70.92044, name: 'Middleboro'},
  {id:40,lat:41.69284, lng:-70.93521, name: 'New Bedford'},
  {id:40,lat:41.92885, lng:-70.65334, name: 'Plymouth'},
  {id:40,lat:41.743077, lng:-71.192358, name: 'Swansea'},
  {id:40,lat:41.640024, lng:-71.021447, name: 'Dartmouth'},
]
};
export default state;